import dataModal from './dataModal.vue'
const _dataModal = {
    install:function(Vue){
        Vue.component('WtDataModal',dataModal)
    }
}
export default _dataModal


// WEBPACK FOOTER //
// ./src/components/Public/dataModal/dataModal.js